import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { productPrice } from 'src/app/pages/orders/interfaces/order.Interface';

@Injectable({ providedIn: 'root' })
export class ProductPriceApiService {
  private baseHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey);

  constructor(private http: HttpClient) {}

  getProductPrice(params: { customerId: number; productId: number; plantId: number }): Observable<productPrice[]> {
    const url = `${environment.APIM}${environment.newOrderAPI}CustomerCashPrice/`;
    return this.http.post<productPrice[]>(url, params, { headers: this.baseHeaders });
  }
}
